import React from 'react'
import { IconStorefront, Text, csx } from '@vtex/admin-ui'
import { useIntl } from 'react-intl'

import { DetailsBlockTemplate } from './DetailsBlockTemplate'
import {
  useOrderFormShippingEstimate,
  useFormatCurrency,
} from '../../../../hooks'
import type { Package } from '../../../../../../core/typings'
import { getDetailsScheduledDelivery, hasScheduledDelivery } from '../../utils'

export type PickupDetailsBlockProps = {
  currentPackage: Package
}

const getPickupNameFromPackage = (pkg: Package) =>
  pkg.selectedSlaObj?.pickupStoreInfo?.friendlyName ?? ''

const getPackagePrice = (pkg: Package) => pkg.price / 100

export const PickupDetailsBlock = ({
  currentPackage,
}: PickupDetailsBlockProps) => {
  const { getEstimateMessage } = useOrderFormShippingEstimate()
  const { formatMessage } = useIntl()
  const formatCurrency = useFormatCurrency()
  const shippingValue = formatCurrency(getPackagePrice(currentPackage))

  const estimateMessage = getEstimateMessage(
    currentPackage.selectedSlaObj?.shippingEstimate ?? ''
  )

  return (
    <DetailsBlockTemplate
      data-testid="shipping-details-pickup-block"
      icon={<IconStorefront />}
      title={
        hasScheduledDelivery(currentPackage)
          ? formatMessage({
              id: 'checkout.shipping-method-selection.schedule-delivery-title',
            })
          : formatMessage({ id: 'checkout.pickup-in-store' })
      }
      details={
        <Text
          variant="detail"
          tone="secondary"
          className={csx({ display: 'block' })}
        >
          {hasScheduledDelivery(currentPackage)
            ? getDetailsScheduledDelivery(
                currentPackage,
                shippingValue,
                getPickupNameFromPackage(currentPackage)
              )
            : `${getPickupNameFromPackage(
                currentPackage
              )} - ${estimateMessage}`}
        </Text>
      }
      currentPackage={currentPackage}
    />
  )
}
